import {sendErrorEvent} from '../events/EventsService';

function HandleAsyncError() {
    return (target: any, propertyKey: string, descriptor: PropertyDescriptor | any) => {
        const originalMethod = descriptor.value;
        descriptor.value = async function (...args: any[]) {
            try {
                return await originalMethod.apply(this, args);
            } catch (error) {
                const errorContent = `${error.name}\n${error.message}.\n${error.stack}`;
                sendErrorEvent(errorContent);
                this.metricsService.setLogsBuffer(errorContent);
                this.metricsService.renderError();
            }
        };

        return descriptor;
    };
}

export default HandleAsyncError;
